module.exports = __webpack_public_path__ + "media/images/follow-a4c36a8a67e9a40861dcf8f09aae2d6f.svg";